import { render, staticRenderFns } from "./batch-get-patient-benefits-action-input.vue?vue&type=template&id=e28a70d6&scoped=true"
import script from "./batch-get-patient-benefits-action-input.vue?vue&type=script&lang=js"
export * from "./batch-get-patient-benefits-action-input.vue?vue&type=script&lang=js"
import style0 from "./batch-get-patient-benefits-action-input.vue?vue&type=style&index=0&id=e28a70d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28a70d6",
  null
  
)

export default component.exports